import { create } from 'zustand'

import type { AdaptedStockDTO } from '@/domain'

type PeriodType = 'day' | 'week' | 'month' | 'year'

export interface Period {
  id: string
  period: PeriodType
  translationKey: string
}

export const periods: Period[] = [
  {
    id: 'f0e5d1a9-84d3-4b62-9d13-caf8d5e158ed',
    period: 'day',
    translationKey: 'periods:day',
  },
  {
    id: 'c2561bfa-22f3-4c9a-9b50-f7a14f298542',
    period: 'week',
    translationKey: 'periods:week',
  },
  {
    id: 'a4d61699-cf6f-472b-b1ca-17a8ff3b9809',
    period: 'month',
    translationKey: 'periods:month',
  },
  {
    id: '6cc7db89-1849-42c1-b722-870d72f5a0c6',
    period: 'year',
    translationKey: 'periods:year',
  },
]

interface StocksStoreState {
  searchValue: string
  selectedFilters: string[]
  chartPeriod: Period
  selectedStockData?: AdaptedStockDTO
  pricePerShare: number
  holdingValue: number
}

interface StocksStoreFunctions {
  setSearchValue: (searchValue: string) => void
  toggleSelectedFilter: (category: string) => void
  setChartPeriod: (chartPeriod: Period) => void
  setSelectedStockData: (selectedStockData?: AdaptedStockDTO) => void
  setPricePerShare: (pricePerShare: number) => void
  setHoldingValue: (holdingValue: number) => void
}

export type StocksStore = StocksStoreState & StocksStoreFunctions

const initialState: StocksStoreState = {
  searchValue: '',
  selectedFilters: [],
  chartPeriod: periods[0],
  selectedStockData: undefined,
  pricePerShare: 0,
  holdingValue: 0,
}

export const useStocksStore = create<StocksStore>()((set) => ({
  ...initialState,
  setSearchValue: (searchValue) => set({ searchValue }),
  toggleSelectedFilter: (category) =>
    set((state) => {
      const isSelected = state.selectedFilters.includes(category)
      const selectedFilters = isSelected
        ? state.selectedFilters.filter((f) => f !== category)
        : [...state.selectedFilters, category]
      return { selectedFilters }
    }),
  setChartPeriod: (chartPeriod) => set({ chartPeriod }),
  setSelectedStockData: (selectedStockData) => set({ selectedStockData }),
  setPricePerShare: (pricePerShare) => set({ pricePerShare }),
  setHoldingValue: (holdingValue) => set({ holdingValue }),
}))
